// Firebase configuration and initialization
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyC2c4Y5nPGfrFe4giIy6mzWaziUJeNpuAM",
  authDomain: "loyalty-app-5ts2zv.firebaseapp.com",
  projectId: "loyalty-app-5ts2zv",
  storageBucket: "loyalty-app-5ts2zv.firebasestorage.app",
  messagingSenderId: "928403114668",
  appId: "1:928403114668:web:944c970868aa299ae26d09"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };
